import layoutDefs from "./layoutDefs.json";
import schemaDefs from "./schemaDefs.json";
import optionsDefs from "./optionsDefs.json";

export const FORM_DEFINITION_MODEL_URI = "https://rpaconnect.io/formDefinition";
const formDefinitionJsonSchema = {
  uri: "https://app.rpaconnect.io/schema.json",
  fileMatch: [FORM_DEFINITION_MODEL_URI],
  schema: {
    $schema: "https://json-schema.org/draft-07/schema",
    $id: "https://app.rpaconnect.io/schemas/formDefinition",
    additionalProperties: false,
    type: "object",
    properties: {
      schema: {
        $ref: "#/$defs/schema/IFormSchema",
      },
      layout: {
        $ref: "#/$defs/layout/Layout",
      },
      options: {
        $ref: "#/$defs/options/Options",
      },
    },
    required: ["schema", "layout", "options"],
    $defs: {
      schema: schemaDefs,
      layout: layoutDefs,
      options: optionsDefs,
    },
  },
};
export default formDefinitionJsonSchema;
